<template>
	<div
		class="news_listing scrollanchor"
		ref="news_listing"
	>
		<div class="container-wrapper">
			<div class="container top">
				<div
					class="upper_banner"
					:class="{'no-filter': show_filter === '' || paginatedData.length <= 1}"
				>

					<h5>Filter By</h5>

					<ul
						class="filter-cats"
						v-if="
            show_filter === 'on' ||
            (show_filter === '1' &&
              paginatedData.length >= 0 &&
              Object.keys(parsedCategories).length > 0)
          "
					>
						<secondary-button
							v-on:click.native="currentFilter = 'all'"
							:class="{ current: currentFilter == 'all' }"
							:label="'All'"
							:link="false"
							theme='filter'
						></secondary-button>

						<secondary-button
							v-for="(category, index) in parsedCategories"
							:key="index"
							:id="category.id"
							v-on:click.native="
              currentFilter === category.slug
                ? (currentFilter = 'all')
                : (currentFilter = category.slug)
            "
							:class="{ current: category.slug == currentFilter }"
							:label="category.name"
							:link="false"
							theme='filter'
						></secondary-button>

						<!-- <a
								class="reset-filters"
								@click.prevent="currentFilter = 'all'"
								href
							>Reset Filters</a> -->
					</ul>

				</div>

			</div>

		</div>
		<div class="container bottom">

			<div class="lower_banner">

				<div class="no-posts counts">
					<h4
						class="no-posts"
						v-if="paginatedData.length === 0 && !busy"
						v-html="no_posts_message"
					>
					</h4>
					<h4
						class="no-posts"
						v-else-if="paginatedData.length != 0 && !busy"
						v-html="showingOf"
					></h4>
					<loading-animation v-if="busy === true"></loading-animation>
				</div>
			</div>

			<template>

				<!-- <transition name="fade">
					<div
						class="overlay"
						v-if="busy === true"
					>
						<loading-animation></loading-animation>
					</div>
				</transition> -->

				<template v-if="busy != true">
					<post-tile
						v-for="(post, index) in paginatedData"
						:key="index"
						:name="post.title"
						:short_description="post.excerpt"
						:image="post.image"
						:permalink="{'url': post.permalink, 'target': '_self', 'title': 'Read More'}"
						:class="post.post_type"
						:tag="post.category"
						:post_type="post.post_type"
						:video="false"
						data-aos="fade-up"
						data-aos-duration="300"
						:data-aos-offset="50"
						:data-aos-delay="index * 50"
					></post-tile>

				</template>

			</template>

			<ul
				class="page-numbers"
				v-if="
            pageCount != 1 &&
            show_pagination === '1' &&
            paginatedData.length != 0
          "
			>
				<li v-if="pageNumber != 0">
					<a
						@click="pageNumber--"
						class="prev page-numbers"
					>
						<div class="arrow_container">
							<chevron-right></chevron-right>
						</div>
						<span>Previous</span>
					</a>
				</li>

				<li
					v-for="(post, index) in pageCount"
					:key="index"
				>
					<a
						@click="pageNumber = index"
						class="page-numbers"
						:class="{ current: index == pageNumber }"
						v-html="index + 1"
					></a>
				</li>

				<li v-if="pageNumber != pageCount - 1">
					<a
						@click="pageNumber++"
						class="next page-numbers"
					><span>Next</span>
						<div class="arrow_container">
							<chevron-right></chevron-right>
						</div>
					</a>
				</li>
			</ul>

		</div>
	</div>
</template>

<script>
import PostTile from './PostTile.vue';
import LoadingAnimation from './LoadingAnimation.vue';
import SecondaryButton from './SecondaryButton.vue';
import ChevronRight from './ChevronRight.vue';

export default {
	/* eslint-disable no-undef */

	data() {
		return {
			show_filter: 'on',
			show: false,
			currentFilter: [],
			currentRegion: [],
			currentStatus: [],
			currentType: [],
			currentSort: 'latest-oldest',
			visible: true,
			pageNumber: 0, // default to page 0
			paginatedStuff: this.pagination(),
			number_of_posts: this.number_posts_per_page(),
			dropdownClicked: false,
			window: {
				width: 0,
				height: 0,
			},
			busy: false,
			searchTerm: '',
			filteredPosts: [],
			region_modal: false,
			user_modal: false,
			attributes: {
				ref: 'openIndicator',
				role: 'presentation',
				class: 'vs__open-indicator',
			},
		};
	},

	props: {
		size: {
			default: 'one',
		},
		posts: {},
		categories: {},
		show_title: {},
		title: {},
		show_pagination: {},
		show_sort: {},
		data_size: {
			type: Number,
			required: false,
			default: 12,
		},
		posts_per_page: {
			required: true,
		},
		button_type: {
			default: 'normal',
		},
		no_posts_message: {},
		asset_url: {},
	},

	computed: {
		showingOf() {
			let page = this.pageNumber + 1;
			let totalCount = this.filteredCategory.length;
			let postsPerPage = this.number_of_posts;

			let startCount = !page ? 1 : (page - 1) * postsPerPage + 1;
			let endCount = startCount + (postsPerPage - 1);

			if (endCount > totalCount) {
				endCount = totalCount;
			}

			return 'Showing ' + startCount + '-' + endCount + ' of ' + totalCount;
		},

		pageCount() {
			let l = this.filteredCategory.length,
				s = this.number_of_posts;
			return Math.ceil(l / s);
		},

		paginatedData() {
			const start = this.pageNumber * this.number_posts_per_page(),
				end = start + this.number_of_posts;
			return this.filteredCategory != null
				? this.filteredCategory.slice(start, end)
				: false;
		},

		parsedCategories() {
			if (this.categories) {
				return JSON.parse(this.categories);
			} else {
				return null;
			}
		},

		parsedPosts() {
			if (this.posts) {
				return JSON.parse(this.posts);
			} else {
				return null;
			}
		},

		// eslint-disable-next-line no-unused-vars

		filteredCategory() {
			var vm = this;
			var category = vm.currentFilter;
			var sort = vm.currentSort;
			var thePosts = vm.parsedPosts;

			if (sort === 'latest-oldest') {
				if (category === 'all') {
					return thePosts.sort((a, b) => new Date(b.date) - new Date(a.date));
				} else {
					return thePosts
						.filter(function (article) {
							const catCheck = (element) => element['slug'] === category;
							let articleCategoryArray = Array.isArray(article.category)
								? Array.from(article.category)
								: [];
							return articleCategoryArray.some(catCheck);
						})
						.sort((a, b) => new Date(b.date) - new Date(a.date));
				}
			} else if (sort === 'alpha') {
				if (category === 'all') {
					return thePosts.sort((a, b) => a.title.localeCompare(b.title));
				} else {
					return thePosts
						.filter(function (article) {
							const catCheck = (element) => element['slug'] === category;
							let articleCategoryArray = Array.isArray(article.category)
								? Array.from(article.category)
								: [];
							return articleCategoryArray.some(catCheck);
						})
						.sort((a, b) => a.title.localeCompare(b.title));
				}
			} else {
				if (category === 'all') {
					return thePosts.sort((a, b) => new Date(a.date) - new Date(b.date));
				} else {
					return thePosts
						.filter(function (article) {
							const catCheck = (element) => element['slug'] === category;
							let articleCategoryArray = Array.isArray(article.category)
								? Array.from(article.category)
								: [];
							return articleCategoryArray.some(catCheck);
						})
						.sort((a, b) => new Date(a.date) - new Date(b.date));
				}
			}
		},
	},

	watch: {
		currentFilter() {
			this.loadPosts();
		},

		pageNumber() {
			this.loadPosts();
		},
	},

	methods: {
		async scrollPage() {
			await this.sleep(250);
			let scrollAnchor = document.querySelector('.scrollanchor');
			let scrollAnchorOffset = scrollAnchor.offsetTop;
			if (scrollAnchor) {
				window.scrollTo({ top: scrollAnchorOffset - 250, behavior: 'smooth' });
			}
		},

		nextPage() {
			this.pageNumber++;
		},
		prevPage() {
			this.pageNumber--;
		},

		pagination() {
			let parsed = JSON.parse(this.posts);
			return parsed;
		},

		number_posts_per_page() {
			let the_result = JSON.parse(this.posts_per_page);
			return the_result.number;
		},

		handleResize() {
			this.window.width = window.innerWidth;
			this.window.height = window.innerHeight;
		},

		sleep(ms) {
			return new Promise((resolve) => setTimeout(resolve, ms));
		},

		shouldDisplayPage(index) {
			const { pageNumber, pageCount } = this;

			if (index === 0 || index === pageCount - 1) {
				return true; // Always display the first and last page
			}

			// if (index <= 2) {
			// 	return true; // Initially display the first 3 pages and the last page
			// }

			if (Math.abs(index - pageNumber) <= 1) {
				return true; // Display the current page and adjacent pages
			}

			if (pageNumber >= 2 && index === pageNumber - 2) {
				return true; // Display the page before the current page when 4 pages before the last page
			}

			if (pageNumber <= pageCount - 3 && index === pageNumber + 2) {
				return true; // Display the page after the current page when 4 pages before the last page
			}

			if (index === 1 && pageNumber === 3) {
				return true; // Display the second page when on the third page
			}

			return false; // Replace all other pages with ellipses
		},

		shouldDisplayEllipsis(index) {
			const { pageNumber, pageCount } = this;
			if (
				(index === pageNumber - 3 &&
					pageNumber >= Math.floor(pageNumber / 2)) ||
				(index === pageNumber + 3 && pageNumber <= pageCount - 5)
			) {
				return true;
			}
			return false;
		},

		checkQueryString() {
			const urlParams = new URLSearchParams(window.location.search);
			const category = urlParams.get('category');

			if (category) {
				this.currentFilter = category;
			}
		},

		async loadPosts() {
			this.busy = true;
			await this.sleep(300);
			window.scrollTo({ top: 0, behavior: 'smooth' });
			await this.sleep(1000);
			this.busy = false;
		},
	},

	components: {
		PostTile,
		LoadingAnimation,
		SecondaryButton,
		ChevronRight,
	},

	created() {
		this.currentFilter = 'all';
		window.addEventListener('resize', this.handleResize);
		window.addEventListener('load', this.handleResize);
		window.dispatchEvent(new Event('resize'));
		this.handleResize();
	},

	destroyed() {
		window.removeEventListener('scroll', this.didScroll);
		window.removeEventListener('resize', this.handleResize);
	},
	mounted() {
		this.handleResize();
		this.checkQueryString();
	},
	change() {
		window.dispatchEvent(new Event('resize'));
		this.handleResize();
	},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.news_listing {
	// margin-top: var(--gutter-tablet-desktop);
	padding-bottom: 50px;
	position: relative;
	/* overflow: hidden; */
	/* min-height: 650px; */
	/* background: var(--white); */
	z-index: 820;

	@media (max-width: $mobile-xl) {
		margin-top: -100px;
	}

	.overlay {
		background: var(--white);
		color: var(--midnight);
		position: absolute;
		z-index: 20;
		width: 100%;
		height: 100%;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		display: flex;
		align-items: flex-end;
		justify-content: center;
	}

	.container-wrapper {
		position: relative;
		/* overflow: hidden; */
		background: var(--light-grey);

		> svg {
			position: absolute;
			bottom: 0;
			right: -85px;
			z-index: 0;

			@media (max-width: $mobile-xl) {
				display: none;
			}
		}
	}

	.container {
		&.top {
			padding-top: 32px;
			padding-bottom: 32px;
			overflow: unset;

			@media (max-width: $max-width) {
				max-width: 100%;
				margin: 0 24px;
				padding: 24px 0 24px 0;
			}

			.upper_banner {
				z-index: 10;
			}
		}

		&.bottom {
			column-gap: 24px;
			row-gap: 40px;
			max-width: var(--max-width);
			position: relative;

			@media (max-width: $mobile-xl) {
				padding-top: 24px;
				row-gap: 24px;
			}
		}

		@media (max-width: $tablet) and (orientation: portrait) {
			grid-template-columns: repeat(8, 1fr);
			gap: var(--gutter-tablet-desktop);
			// padding: 0 calc(var(--spacer) * 2);
		}

		@media (max-width: $tablet) {
			grid-template-columns: repeat(12, 1fr);
			column-gap: var(--gutter-mobile);
			row-gap: var(--gutter-mobile);
		}

		@media (max-width: $mobile-xl) {
			grid-template-columns: repeat(4, 1fr);
			column-gap: var(--gutter-mobile);
		}

		/* .filter-cats {
			@media (max-width: $tablet) and (orientation: portrait) {
				grid-column: span 12;
			}

			@media (max-width: $tablet) and (orientation: landscape) {
				grid-column: span 12;
			}

			@media (max-width: $mobile-xl) {
				grid-column: span 4;
			}
		} */

		/* .page-numbers {
			@media (max-width: $tablet) and (orientation: portrait) {
				grid-column: span 8;
			}

			@media (max-width: $tablet) and (orientation: landscape) {
				grid-column: span 12;
			}

			@media (max-width: $mobile-xl) {
				grid-column: span 4;
			}
		} */

		.post_tile {
			@media (max-width: 1920px) {
				grid-column: span 3;
			}

			@media (max-width: 1490px) {
				grid-column: span 3;
			}

			// @media (max-width: $tablet) {
			// 	grid-column: span 2;
			// }

			@media (max-width: $mobile-xl) {
				grid-column: span 4;
			}
		}
	}

	.upper_banner,
	.lower_banner {
		padding: 0;
		grid-column: 1 / span 12;

		@media (max-width: $tablet) and (orientation: portrait) {
			grid-column: 1 / span 8;
		}

		@media (max-width: $mobile-xl) {
			padding: 0;
		}

		h4 {
			color: var(--midnight);
			/* padding-bottom: calc(var(--spacer) * 2); */
			margin: 0 0 16px;
		}
	}

	.no-posts {
		padding: 0 calc(var(--spacer) * 2);
		grid-column: 3 / span 8;
		display: flex;
		justify-content: center;
		align-items: center;
		font: normal normal normal 14px/18px var(--primary-font-family);
		color: unset;
		text-transform: unset;
		margin: 0;
		color: var(--midnight);

		@media (max-width: $mobile-xl) {
			grid-column: 1 / span 2;
			padding: 0 0;
			flex-wrap: wrap;
			gap: 24px;
			width: 100%;
			justify-content: flex-start;
		}

		p {
			text-decoration: underline;
			font: normal normal normal 14px/18px var(--primary-font-family);
			letter-spacing: 0.28px;
			color: var(--midnight);
			text-transform: uppercase;
			padding: 0 16px;
			margin: 0;

			&:hover {
				cursor: pointer;
			}

			&.current {
				font: normal normal bold 14px/18px var(--primary-font-family);
			}
		}
	}

	.lower_banner {
		grid-column: 1 / span 12;
		display: grid;
		grid-template-columns: repeat(12, 1fr);
		width: 100%;
		padding: 56px 0 0;

		&.no-filter {
			@media (min-width: $mobile-xl) {
				border-top: 1px solid var(--midnight);
				padding-top: var(--gutter-tablet-desktop);
			}
		}

		@media (max-width: $laptop) {
			grid-column: span 12;
		}

		@media (max-width: $tablet) {
			grid-column: span 12;
		}

		/* @media (max-width: $mobile-xl) {
			display: grid;
			grid-template-columns: repeat(4, 1fr);
			grid-column: span 4;
			padding-bottom: 16px;
		} */

		@media (max-width: $mobile-xl) {
			display: none;
		}

		.filter-sort-container {
			grid-column: 11 / span 2;
			display: flex;
			flex-wrap: wrap;
			flex-direction: row;
			justify-content: flex-end;
			align-items: center;

			@media (max-width: $mobile-xl) {
				grid-column: span 2;
				width: 100%;
				justify-content: flex-end;
			}
		}

		.filter-sort {
			display: flex;
			flex-wrap: wrap;
			flex-direction: row;
			list-style: none;
			margin: 0;
			padding: 0;
			justify-content: flex-end;
			position: relative;
			align-items: center;

			@media (max-width: $tablet) and (orientation: portrait) {
				grid-column: 10 / span 3;
			}

			&.clicked {
				&::before {
					transform: rotate(180deg);
					transition: 0.2s ease all;
				}
			}

			@media (max-width: $mobile-xl) {
				grid-column: 1 / span 4;
				flex-wrap: wrap;
				grid-row: 1;
			}

			select {
				-webkit-appearance: none;
				-moz-appearance: none;
				appearance: none;
				border-radius: 0;
				opacity: 1;
				padding: 0 16px 0 0;
				border: 0;
				outline: none;
				width: 100%;
				grid-column: span 4;
				background-color: white;
				background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iOSIgdmlld0JveD0iMCAwIDE0IDkiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNi43MDY5MSA1LjU4NTQyTDExLjk5OTYgMC4yOTI3MjVMMTMuNDEzOCAxLjcwNjk0TDYuNzA2OTEgOC40MTM4NUwwIDEuNzA2OTRMMS40MTQyMSAwLjI5MjcyNUw2LjcwNjkxIDUuNTg1NDJaIiBmaWxsPSIjMDBBRUVGIi8+Cjwvc3ZnPgo=');
				background-size: 10px 10px;
				background-position: 100% 7px;
				background-repeat: no-repeat;
				border-radius: 0;
				color: var(--midnight);
				font: normal normal normal 14px/20px var(--primary-font-family);

				option {
					color: var(--midnight);
					font: normal normal normal 14px/20px var(--primary-font-family);
				}

				&:hover {
					cursor: pointer;
					transition: 0.2s ease all;
				}
			}

			h2 {
				margin-right: calc(var(--spacer) / 2);
				font-weight: bold;

				a {
					text-decoration: none;
					font-weight: bold;

					&:hover {
						cursor: pointer;
					}

					&.current {
						color: var(--midnight);
					}
				}
			}
		}
	}

	.upper_banner {
		display: grid;
		grid-template-columns: repeat(12, 1fr);
		column-gap: 24px;
		grid-column: span 12;
		width: 100%;
		padding: 0 0 0;
		gap: 24px;

		@media (max-width: $laptop) {
			grid-column: span 12;
		}

		@media (max-width: $tablet) {
			grid-column: span 12;
		}

		@media (max-width: $mobile-xl) {
			grid-template-columns: repeat(4, 1fr);
			grid-column: span 4;
			padding: 0 0 0;
			/* display: flex;
			flex-direction: column;
			flex-wrap: wrap;
			border-top: unset;
			justify-content: flex-start;
			align-items: flex-start;
			gap: 24px; */
		}

		h5 {
			margin: 0;
			text-transform: uppercase;
		}

		.filter-cats {
			grid-column: span 12;
			display: flex;
			flex-direction: row;
			column-gap: 8px;
			row-gap: 22px;
			padding: 0;
			justify-content: flex-start;
			align-items: flex-end;
			flex-wrap: wrap;
			position: relative;
			z-index: 5;

			@media (max-width: $mobile-xl) {
				grid-column: span 4;
				width: 100%;
				padding: 0 0 0;
				row-gap: 8px;
			}

			.reset-filters {
				text-decoration: underline;
				font: normal normal normal 16px/24px var(--primary-font-family);
				color: var(--light-blue);
				padding-top: 0;

				&:hover {
					text-decoration: underline;
					font: normal normal normal 16px/24px var(--primary-font-family);
					color: var(--light-blue);
				}
			}
		}
	}

	/* a:not(.page-numbers):not(.page-numbers-exterior) {
		border-radius: 22px;
		border: 1px solid var(--midnight);
		font: normal normal normal 14px/20px var(--primary-font-family);
		color: var(--midnight);
		background: transparent;
		padding: 8px 16px 6px;
		display: flex;

		&.reset {
			cursor: pointer;
			transition: 0.2s ease all;
			background: transparent;
			padding: 0 0 1px;
			color: var(--midnight);
			font: normal normal normal 16px/24px var(--primary-font-family);
			border: 0;
			border-radius: 0;
			border-bottom: 1px solid var(--midnight);
			text-decoration: none;

			@media (max-width: $mobile-xl) {
				margin: 10px 0;
			}

			&:hover {
				cursor: pointer;
			}
		}

		&[disabled='disabled'] {
			opacity: 0.25;
			pointer-events: none;
		}
	} */

	select {
		&.mobile-filter-cats {
			-webkit-appearance: none;
			-moz-appearance: none;
			appearance: none;
			border-radius: 0;
			opacity: 1;
			padding: 12px calc(16px + 17px + 16px) 12px 16px;
			border: 0;
			outline: none;
			width: 100%;
			grid-column: span 4;
			background-color: var(--white);
			background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iOCIgdmlld0JveD0iMCAwIDEyIDgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xIDFMNiA2TDExIDEiIHN0cm9rZT0iIzAwMkY0MSIgc3Ryb2tlLXdpZHRoPSIxLjY2NyIvPgo8L3N2Zz4K');
			background-size: 14px 14px;
			background-position: calc(100% - 16px);
			background-repeat: no-repeat;
			color: var(--midnight);

			@media (max-width: $tablet) {
				grid-column: span 12;
			}

			@media (max-width: $mobile-xl) {
				grid-column: span 4;
				grid-template-columns: repeat(4, 1fr);
			}

			option {
				color: var(--midnight);
			}

			&:hover {
				cursor: pointer;
				transition: 0.2s ease all;
			}
		}
	}

	.news & {
		select {
			background-color: var(--wheat);
		}
	}
	// .article_card {
	// 	grid-column: span 4;

	// 	@media (max-width: $tablet) {
	// 		grid-column: span 6;
	// 	}

	// 	@media (max-width: $mobile-xl) {
	// 		grid-column: span 12;
	// 	}
	// }

	.pagination_container {
		display: flex;
		flex-direction: row;
		gap: 68px;
		width: auto;
		justify-content: center;
		align-items: center;
		padding: 0;
		margin: 0;
		grid-column: 1 / span 12;

		@media (max-width: $mobile-xl) {
			gap: 24px;
			grid-column: span 4;
		}
	}

	.page-numbers-exterior {
		text-decoration: none;
		font: normal normal bold 14px/18px var(--primary-font-family);
		display: flex;
		justify-content: center;
		align-items: center;
		color: var(--midnight);
		background: transparent;
		transition: 0.2s ease all;

		&:hover {
			cursor: pointer;
			transition: 0.2s ease all;

			&:not(.next):not(.prev) {
				background: var(--midnight);
				color: white;
			}
		}

		&.current {
			transition: 0.2s ease all;
			background: var(--electric-yellow);
			color: white;
			font: normal normal bold 14px/18px var(--primary-font-family);
		}

		&.next {
			position: relative;

			span {
				display: block;
				font: normal normal bold 14px/18px var(--primary-font-family);
				text-transform: uppercase;
				text-indent: 0;
			}

			svg {
				margin-left: 10px;
				text-indent: 0;
				display: flex;
			}
		}

		&.prev {
			span {
				display: block;
				font: normal normal bold 14px/18px var(--primary-font-family);
				text-transform: uppercase;
				text-indent: 0;
			}

			svg {
				margin-right: 10px;
				text-indent: 0;
				display: flex;
				transform: rotate(-180deg);
			}
		}
	}

	ul.page-numbers {
		display: flex;
		flex-direction: row;
		gap: 0;
		width: auto;
		justify-content: center;
		align-items: center;
		padding: 0;
		margin: 16px 0 0;
		grid-column: 1 / span 12;

		@media (max-width: $mobile) {
			gap: 0;
			grid-column: span 4;
		}

		li {
			display: inline-flex;
			align-items: center;
			justify-content: center;

			.page-numbers {
				text-decoration: none;
				font: normal normal normal 16px/20px var(--primary-font-family);
				width: 32px;
				height: 32px;
				display: flex;
				justify-content: center;
				align-items: center;
				color: var(--midnight);
				background: transparent;
				transition: 0.2s ease all;
				border-radius: 50%;

				&:hover {
					cursor: pointer;
					transition: 0.2s ease all;

					&:not(.next):not(.prev) {
						background: var(--cobalt);
						color: var(--white);
					}
				}

				@media (max-width: $mobile) {
					/* gap: 0;
					width: 24px;
					height: 24px; */
					/* font: normal normal normal 12px/16px var(--primary-font-family); */
				}

				&.current {
					transition: 0.2s ease all;
					background: var(--cobalt);
					color: var(--white);
					font: normal normal normal 16px/20px var(--primary-font-family);
				}

				&.next {
					position: relative;
					// overflow: hidden;
					text-indent: -9999px;
					content: '';
					width: 100px;

					&:hover {
						.arrow_container {
							transform: scale(1.4);
							transition: 0.2s ease all;
						}
					}

					span {
						display: block;
						font: normal normal normal 16px/20px var(--primary-font-family);
						text-indent: 0;
						position: absolute;
						right: 20px;
					}

					.arrow_container {
						position: absolute;
						right: 0;
						text-indent: 0;
						display: flex;
					}
				}

				&.prev {
					position: relative;
					// overflow: hidden;
					text-indent: -9999px;
					content: '';
					width: 100px;

					&:hover {
						.arrow_container {
							transform: scale(1.4);
							transition: 0.2s ease all;
						}
					}

					span {
						display: block;
						font: normal normal normal 16px/20px var(--primary-font-family);
						text-indent: 0;
						position: absolute;
						left: 20px;
					}

					.arrow_container {
						position: absolute;
						left: 0;
						text-indent: 0;
						display: flex;

						svg {
							transform: scaleX(-100%);
						}
					}
				}
			}
		}
	}

	.news_listing__item {
		&.not_visible {
			display: none;
		}

		&.visible {
			display: flex;
		}
	}
}

.slide-fade-enter-active {
	transition: opacity 0.2s ease;
	transition-delay: 0.3s;
}

.slide-fade-leave-active {
	transition: opacity 0.2s cubic-bezier(1, 0.5, 0.8, 1);
	// transition-delay: .4s;
}

.slide-fade-enter,
.slide-fade-leave-to {
	opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
	transition: all 0.5s ease;
}
.fade-enter,
.fade-leave-to {
	opacity: 0;
}

.list-enter-active,
.list-leave-active {
	transition: all 0.5s ease;
}
.list-enter-from,
.list-leave-to {
	opacity: 0;
	transform: translateX(30px);
}
</style>
